import { INSTRUMENTATION_TYPES } from '../constants'

export function getAnalyticsMeta(type, payload) {
  return { analytics: { type, payload } }
}

export function fromChoiceToReview(analyticsData) {
  const linkName = 'next'

  return getAnalyticsMeta(INSTRUMENTATION_TYPES.ACTION_WITH_DATA, {
    linkName,
    data: analyticsData,
    trackType: 'link',
  })
}
